(function ($) {
  /* --------------------------- Edit/Cancel Toggle --------------------------- */
  const accountEditInit = function () {
    $(document).on('click', '.btn-edit', function (e) {
      e.preventDefault();
      const target = $(this).data('edit-target');
      const panel = $(`[data-id="${target}"]`);
      const edit = $(this).data('edit');
      const cancel = $(this).data('cancel');
      const forceHide = $('.body-content');

      let slidePanel = null;

      $('.container-account .component-account .infobody').addClass('active');
      if ($(this).attr('id') !== 'link-address2InfoPanel') {
        $('#address2InfoBody.hideextra .keepopen:not(.hideextra)').attr('style', 'display: flex !important');
      } else {
        $('#address2InfoBody.hideextra .keepopen:not(.hideextra)').attr('style', '');
      }

      if ($(this).hasClass('keepopen')) {
        slidePanel = $(this).parent().parent().parent().next('.component-account-edit-details');
      } else {
        slidePanel = $(this).parent().parent().parent().find('.component-account-edit-details');
      }
      if(target == "emailInfoPanel" || target == "contactInfoPanel"){
        slidePanel = $('#'+target);
      }

      $('.component-account-edit-details').slideUp(0).attr('style', '');
      $(slidePanel).slideToggle(250);

      $(this).parent().parent().find('.body').find('.body-content').addClass('forcehide');

      $('.component-account-edit-details').removeClass('active');
      $(forceHide).removeClass('forcehide');

      if ($(this).hasClass('active')) {
        $(panel).siblings('.infobody.active').find('.body-2').removeClass('active');
        $(this).removeClass('active').find('span').text(edit); // Revert text label
        $(panel).removeClass('active');
        $(panel).siblings('.infobody').addClass('active');
        $(panel).parents().siblings('.infobody').addClass('active');

        if ($(this).parent().parent().hasClass('payment')) {
          $(panel).closest('.infobody').addClass('active');
        } else {
          $(panel).closest('.infobody').removeClass('active');
        }

        $('.component-account-title').each(function () {
          const changeText = $(this).find('.btn-edit').attr('data-edit');
          $(this).find('.btn-edit').removeClass('active');
          $(this).find('.btn-edit').find('span').text(changeText);
        });

        $('.component-account-field').each(function () {
          const changeText = $(this).find('.btn-edit').attr('data-edit');
          $(this).find('.btn-edit').removeClass('active');
          $(this).find('.btn-edit').find('span').text(changeText);
        });
        if ($(this).attr('id') === 'link-address2InfoPanel') {
          $(this).parentsUntil('.component-account').removeClass('hideextra');
        }

        // Reset the textboxes to the original values from when they opened the edit panel
        $("#" + target + " input[type=text]").each(function () {
          $(this).val($(this).data("original-value"));
        });
      } else {
        
        // Reset other panels
        $('.component-account-title').each(function () {
          const changeText = $(this).find('.btn-edit').attr('data-edit');
          $(this).find('.btn-edit').removeClass('active');
          $(this).find('.btn-edit').find('span').text(changeText);
        });

        $('.component-account-field').each(function () {
          const changeText = $(this).find('.btn-edit').attr('data-edit');
          $(this).find('.btn-edit').removeClass('active');
          $(this).find('.btn-edit').find('span').text(changeText);
        });

        $('.body-2').removeClass('active');
        $(this).parent().parent().find('.body-content').addClass('forcehide');

        $(this).addClass('active').find('span').text(cancel); // Change text label
        $(panel).addClass('active');
        $(panel).siblings('.infobody').removeClass('active');
        if(target == "emailInfoPanel")
          $("#contactInfoBody").addClass('active');
        if(target == "contactInfoPanel")
          $("#emailInfoBody").addClass('active');  
        $(this).parent().parent().parent().addClass('active');
        $(panel).parents().siblings('.infobody').addClass('active');
        $(panel).siblings('.infobody.active').find('.body-2').addClass('active');

        if ($(this).attr('id') === 'link-address2InfoPanel') {
          $(this).parentsUntil('.component-account').addClass('hideextra');
        }

        if ($(this).parent().parent().hasClass('payment')) {
          $(panel).closest('.infobody').addClass('active');
          $(this).parent().parent().siblings('.infobody').addClass('active');
        } else {
          $(panel).closest('.infobody').removeClass('active');
        }
        if($(this).attr("id") == "link-passwordSecurityPanel"){
          $('#passwordSecurityPanel input[type=password]').val("");
          $("#passwordSecurityPanel .password-conditions li").removeClass("pass").removeClass("noPass");
          $("#passwordSecurityForm .error").removeClass("error");
          $(".help-block").addClass("hidden");
        }

        // Preserve the original value of the textboxes in case they cancel
        $("#" + target + " input[type=text]").each(function () {
          $(this).data("original-value", $(this).val());
        });
      }

      if ($(this).attr('id') === 'link-billingNewPaymentPanel') {
        $(this).parentsUntil('.component-account').removeClass('active');
      }
    });
  };

  /* -------------------------- Cancel Button Handler ------------------------- */
  const accountCancelInit = function () {
    const btnCancel = $('.btn-cancel');

    $(document).on('click', '.btn-cancel', function (e) {
      e.preventDefault();
      const target = $(this).data('target');
      const panel = $(`[data-id="${target}"]`);
      const linkID = $(panel).parent().siblings('.infobody').find('.btn-edit.active').attr('id');
      const link = $(`#${linkID}`);
      const linkText = $(link).data('edit');
      const forceHide = $('.body-content');
      const buttonID = $(this).parent().parent().parent().parent().parent().siblings('.infobody').addClass('active');
      const paymentID = $(panel).parent().parent().siblings('infobody').closest('.btn-edit').attr('data-id');
      const primaryCard = $('#link-billingPrimaryCardPanel').attr('data-edit');

      $(panel).removeClass('active').attr('style', '');

      $('.component-account-title').each(function () {
        const changeText = $(this).find('.btn-edit').attr('data-edit');
        $(this).find('.btn-edit').removeClass('active');
        $(this).find('.btn-edit').find('span').text(changeText);
      });

      $('.component-account-field').each(function () {
        const changeText = $(this).find('.btn-edit').attr('data-edit');
        $(this).find('.btn-edit').removeClass('active');
        $(this).find('.btn-edit').find('span').text(changeText);
      });

      $('.btn-edit').removeClass('active');
      $(panel).removeClass('active');
      $(panel).siblings('.infobody').removeClass('active');
      $(link).removeClass('active').find('span').text(linkText);
      $(linkID).removeClass('active');
      $(forceHide).removeClass('forcehide');
      $(buttonID).addClass('active');
      $(paymentID).addClass('active');
      $(this).parent().parent().parent().parent().parent().siblings('.infobody').addClass('active');
      $('#link-billingNewPaymentPanel').removeClass('active');
      $('#link-billingPrimaryCardPanel').removeClass('active').find('span').text(primaryCard);

      if ($(this).attr('id') === 'addPaymentCancel') {
        $('#billingNewPaymentBody').addClass('active');
        $("#billingNewPaymentForm")[0].reset();
        $(".payment-choice").hide();
      }
    });
  };

  const paymentChoiceInit = function () {
    $(document).on('click', '.payment-choice-btn input', function (e) {
      // e.preventDefault();
      // alert($('.payment-choice-btn input:radio:checked').val());
      $(".payment-choice").hide();
      $('#'+$('.payment-choice-btn input:radio:checked').val()).show();
    })
  };
  const init = () => {
    /* ----------------------- Initialize Button Handlers ---------------------- */
    if ($('.btn-edit').length) { accountEditInit(); }
    if ($('.btn-cancel').length) { accountCancelInit(); }
    if($('.payment-choice-btn').length){ paymentChoiceInit(); }
  };

  $(init);
}(jQuery));
